export default __webpack_public_path__ + "static/media/hardwearMenu.a23f575f.png";